import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import NavBar from './NavBar'
import { useIndexedDB } from 'react-indexed-db'
import Action from './Action'
import ObjectDetails from './Object'
import nextY from '../../Assets/Bisoft_UI/Buttons/Active without shadow/next.png'
import backY from '../../Assets/Bisoft_UI/Buttons/Active without shadow/back.png'
import selectbarX from '../../Assets/Bisoft_UI/AppMode/selectbar@2.png'
import ellipse from '../../Assets/Bisoft_UI/AppMode/ellipse.png'
import close from '../../Assets/Bisoft_UI/Buttons/Active without shadow/close.png'
import buttonPlus from '../../Assets/Bisoft_UI/Buttons/Active without shadow/add.png'
import popupCard from '../../Assets/Bisoft_UI/AppMode/appModepopupCard.png'
import styles from './Appmode.module.css'
import Slider from './Slider.js'
import closeBtn from '../../Assets/img/close.png'
import Sliders from 'react-slick'
import leftArrow from '../../Assets/Bisoft_UI/Buttons/Active without shadow/left-arrow.png'
import rightArrow from '../../Assets/Bisoft_UI/Buttons/Active without shadow/right-arrow.png'
import renderPrgImage from '../../source/programImg'
import ProgrammingPageFooter from './ProgrammingPageFooter'
import { connect } from 'react-redux'
import ProgramHeader from '../ReusableComponents/Header/ProgramHeader'

function SampleNextArrow(props) {
    const { className, onClick } = props
    var style = {
        fontSize: '0',
        lineHeight: '0',
        position: 'absolute',
        top: '55%',
        display: 'block',
        padding: '0 0 0 32px',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'transparent',
        border: 'none',
        outline: 'none',
        background: 'transparent',
    }
    return (
        <div>
            <div
                className={'slick-arrow'}
                style={{
                    ...style,
                    // right: "-290px",
                    // height: '25%',
                    zIndex: '1000',
                    // right: '-17%',
                    left: '100%',
                    width: '25%',
                    cursor: 'default',
                }}
            >
                <img
                    src={rightArrow}
                    style={{ width: '30%', cursor: 'grab' }}
                    onClick={onClick}
                ></img>
            </div>
        </div>
    )
}

function SamplePrevArrow(props) {
    const { className, onClick } = props
    var style = {
        fontSize: '0',
        lineHeight: '0',
        position: 'absolute',
        top: '55%',
        display: 'block',
        padding: '0',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'transparent',
        border: 'none',
        outline: 'none',
        background: 'transparent',
    }
    return (
        <div
            className={'slick-arrow'}
            style={{
                ...style,
                left: '16%',
                display: 'block',
                width: '25%',
                zIndex: '1000',
                cursor: 'default',
            }}
        >
            <img
                src={leftArrow}
                style={{ width: '30%', cursor: 'grab', zIndex: '1000' }}
                onClick={onClick}
            ></img>
        </div>
    )
}
var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
}

let allDetails = {}

const Render = (props) => {
    const {
        value,
        id,
        camModels,
        currentModel,
        audioDetails,
        imageDetails,
        setisHumanVoise,
        isHumenVoise,
        enable,
        connectedDevice,
        setChildren,
        messagesEndRef,
    } = props

    const { deleteRecord } = useIndexedDB('ProgramData')

    // default detail object for a programming slot; we merge in any values
    // already persisted under the same key so that navigating away and
    // back doesn't blow them away.
    let details = {
        id: value,
        usbValue: null,
        speechText: null,
        speakerSayThis: null,
        image: null,
        imageURL: null,
        displayText: null,
        selectedSize: null,
        selectedObject: null,
        option: null,
        sliderValue: '1',
        sliderOption: null,
    }

    // if there is already an entry in sessionStorage for this slot we
    // merge it into the defaults.  previously the parent always passed a
    // fresh object which meant any stored values were effectively lost
    // when the user changed something else – later updates would fight the
    // blank object and, in extreme cases, clear the stored record.
    try {
        const stored = JSON.parse(sessionStorage.getItem('allDetails')) || {}
        if (stored[value]) {
            details = { ...details, ...stored[value] }
        }
    } catch (e) {
        // parsing failure should not block rendering
        console.warn('unable to read allDetails from sessionStorage', e)
    }

    const [currentOption, setcurrentOption] = useState(() => {
        try {
            const stored =
                JSON.parse(sessionStorage.getItem('allDetails')) || {}
            const option = stored?.[value]?.option

            return option ? option : 'none'
        } catch {
            return 'none'
        }
    })

    const [speechText, setSpeechText] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${value}` in JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .speechText !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .speechText
        } else {
            return ''
        }
    })

    const [speakerSayThis, setSpeakerSayThis] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${value}` in JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .speakerSayThis !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .speakerSayThis
        } else {
            return ''
        }
    })

    const [usbValue, setUsbValue] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${value}` in JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .usbValue !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .usbValue
        } else {
            return null
        }
    })

    const [object, setObject] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${value}` in JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .selectedObject !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[`${value}`]
                .selectedObject
        } else {
            return 'none'
        }
    })

    useEffect(() => {
        const selectedAudioClass = audioDetails.find(
            (a) => String(a.classKey) === String(object) || String(a.id) === String(object)
        )
        const isHuman = !!(selectedAudioClass?.CategoryName === 'Human')

        if (isHumenVoise[value] !== isHuman) {
            setisHumanVoise((prev) => ({
                ...prev,
                [value]: isHuman,
            }))
        }
    }, [object, audioDetails, value, isHumenVoise, setisHumanVoise])

    const getData = (event) => {
        allDetails = JSON.parse(sessionStorage.getItem('allDetails')) || {}
        // ensure entry for this slot is object, not corrupted string/primitive
        if (value in allDetails) {
            if (
                typeof allDetails[value] !== 'object' ||
                allDetails[value] === null
            ) {
                allDetails[value] = { id: value }
            }
        }

        if (value in allDetails) {
            if (event.target.name === 'speakerSayThis') {
                allDetails[value]['speakerSayThis'] = event.target.value
            } else if (event.target.type === 'text') {
                allDetails[value]['speechText'] = event.target.value
            } else if (
                event.target.type === 'range' ||
                event.target.type === 'number'
            ) {
                allDetails[value]['usbValue'] = event.target.value
            } else {
                if (event.target.type !== 'number') {
                    allDetails[value]['selectedObject'] = event.target.value
                    setObject(event.target.value)
                }
            }
        } else {
            if (event.target.name === 'speakerSayThis') {
                details['speakerSayThis'] = event.target.value
            } else if (event.target.type === 'text') {
                details['speechText'] = event.target.value
            } else if (
                event.target.type === 'range' ||
                event.target.type === 'number'
            ) {
                details['usbValue'] = event.target.value
            } else {
                if (event.target.type !== 'number') {
                    details['selectedObject'] = event.target.value
                    setObject(event.target.value)
                }
            }
            allDetails[`${value}`] = details
        }
        sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
    }

    const handleOnChange = (e) => {
        setcurrentOption(e.target.value)
        allDetails = JSON.parse(sessionStorage.getItem('allDetails')) || {}
        if (value in allDetails) {
            allDetails[value]['option'] = e.target.value
            allDetails[value]['selectedObject'] = null
            allDetails[value]['speechText'] = null
            allDetails[value]['speakerSayThis'] = null
            allDetails[value]['usbValue'] = null
            setSpeechText('')
            setSpeakerSayThis('')
            setUsbValue(null)
            setObject('none')
        } else {
            details['option'] = e.target.value
            allDetails[`${value}`] = details
        }
        sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
    }

    //get device name that show in ui
    const getDeviceName = () => {
        switch (connectedDevice) {
            case 'Ace':
                return 'PC'
            case 'Humanoid':
                return 'Zing'
            case 'Hexapod':
                return 'Crawl-e'
            case 'Klaw':
                return 'Klaw-b'
            case 'Roboki':
                return 'Roboki'
            case 'Klaw':
                return 'klaw-b'
            default:
                return connectedDevice
        }
    }

    const renderoptions = () => {
        if (enable.s1.cam === true && enable.s1.mic === true && enable.s1.pc) {
            if (enable.s2.face === true) {
                return (
                    <>
                        <option value="Face Detected">Cam Detected</option>
                        <option value="speech recognition">
                            speech recognition
                        </option>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}
                        </option>
                    </>
                )
            } else if (enable.s2.emotion === true) {
                return (
                    <>
                        <option value="Emotion Detected">
                            Emotion Detected
                        </option>
                        <option value="speech recognition">
                            speech recognition
                        </option>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}
                        </option>
                    </>
                )
            } else if (enable.s2.object === true) {
                return (
                    <>
                        <option value="Object Detected">Object Detected</option>
                        <option value="speech recognition">
                            speech recognition
                        </option>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                        </option>
                    </>
                )
            }
        } else if (enable.s1.cam === true && enable.s1.mic === true) {
            if (enable.s2.face === true) {
                return (
                    <>
                        <option value="Face Detected">Cam Detected</option>
                        <option value="speech recognition">
                            speech recognition
                        </option>
                    </>
                )
            } else if (enable.s2.emotion === true) {
                return (
                    <>
                        <option value="Emotion Detected">
                            Emotion Detected
                        </option>
                        <option value="speech recognition">
                            speech recognition
                        </option>
                    </>
                )
            } else if (enable.s2.object === true) {
                return (
                    <>
                        <option value="Object Detected">Object Detected</option>
                        <option value="speech recognition">
                            speech recognition
                        </option>
                    </>
                )
            }
        } else if (enable.s1.cam === true && enable.s1.pc === true) {
            if (enable.s2.face === true) {
                return (
                    <>
                        <option value="Face Detected">Cam Detected</option>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                        </option>
                    </>
                )
            } else if (enable.s2.emotion === true) {
                return (
                    <>
                        <option value="Emotion Detected">
                            Emotion Detected
                        </option>
                        <option value="USB">
                            {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                        </option>
                    </>
                )
            } else if (enable.s2.object === true) {
                return (
                    <>
                        <option value="Object Detected">Object Detected</option>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                        </option>
                    </>
                )
            }
        } else if (enable.s1.mic === true && enable.s1.pc === true) {
            return (
                <>
                    <option value="speech recognition">speech recognition</option>
                    <option value="USB">
                        {' '}
                        {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                    </option>
                </>
            )
        } else if (enable.s1.cam === true) {
            if (enable.s2.face === true) {
                return <option value="Face Detected">Cam Detected</option>
            } else if (enable.s2.emotion === true) {
                return (
                    <option value="Emotion Detected">Emotion Detected</option>
                )
            } else if (enable.s2.object === true) {
                return <option value="Object Detected">Object Detected</option>
            }
        } else if (enable.s1.mic === true) {
            return (
                <option value="speech recognition"> speech recognition </option>
            )
        } else if (enable.s1.pc === true) {
            return (
                <>
                    <option value="USB">
                        {' '}
                        {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                    </option>
                </>
            )
        }
    }

    const updateField = (ele) => {
        setSpeakerSayThis(ele.target.value)
        getData(ele)
    }

    const renderobject = () => {
        if (currentOption === 'Face Detected') {
            return (
                <select
                    className={styles.selectBox}
                    style={{ width: '15vw', textAlign: 'center', flexShrink: 0 }}
                    id={value}
                    onChange={getData}
                    value={object}
                >
                    <option value="none">Select an option</option>
                    {imageDetails.map((value, index) => (
                        <option key={index} value={value.id}>
                            {value.className}
                        </option>
                    ))}
                </select>
            )
        } else if (currentOption === 'Emotion Detected') {
            let emotionList = [
                'Suprise',
                'Fear',
                'Angry',
                'Neutral',
                'Sad',
                'Disgust',
                'Happy',
            ]
            return (
                <select
                    className={styles.selectBox}
                    style={{ width: '19vw', textAlign: 'center', flexShrink: 0 }}
                    id={value}
                    onChange={getData}
                    value={object}
                >
                    <option value="none">Select an option</option>
                    {emotionList.map((value, index) => (
                        <option key={index} value={value}>
                            {value}
                        </option>
                    ))}
                </select>
            )
        } else if (currentOption === 'Object Detected') {
            return (
                <select
                    className={styles.selectBox}
                    style={{ width: '19vw', textAlign: 'center', flexShrink: 0 }}
                    id={value}
                    onChange={getData}
                    value={object}
                >
                    <option value="none">Select an option</option>
                    {Object.keys(ObjectDetails).map((value, index) => (
                        <option
                            key={index}
                            value={ObjectDetails[value].displayName}
                        >
                            {ObjectDetails[value].displayName}
                        </option>
                    ))}
                </select>
            )
        } else if (currentOption === 'speech recognition') {
            return (
                <>
                    <span
                        className={styles.labelTag}
                        style={{
                            fontSize: '1.8vh',
                            fontWeight: '600',
                            color: '#555',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        the audio detects
                    </span>
                    <select
                        className={styles.selectBox}
                        style={{
                            width: isHumenVoise[value] ? '10vw' : '12vw',
                            textAlign: 'center',
                            flexShrink: 0,
                        }}
                        id={value}
                        onChange={getData}
                        value={object}
                    >
                        <option value="none">Select audio class</option>
                        {audioDetails.map((val, index) => (
                            <option key={index} value={val.id}>
                                {val.className}
                                {val.CategoryName === 'Human'
                                    ? ' [Human]'
                                    : ' [Sound]'}
                            </option>
                        ))}
                    </select>
                    {isHumenVoise[value] && (
                        <>
                            <span
                                className={styles.labelTag}
                                style={{
                                    fontSize: '1.8vh',
                                    fontWeight: '600',
                                    color: '#555',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                and speech matches
                            </span>
                            <input
                                type="text"
                                name="speakerSayThis"
                                placeholder='"hello"'
                                className={styles.inputWrapper}
                                value={speakerSayThis}
                                onChange={updateField}
                                style={{
                                    width: '9vw',
                                    textAlign: 'center',
                                    flexShrink: 0,
                                }}
                            />
                        </>
                    )}
                </>
            )
        } else if (currentOption === 'USB') {
            return (
                <div style={{ position: 'relative', width: '24vw', height: '5vh', flexShrink: 0 }}>
                    <Slider
                        save={getData}
                        slider={usbValue}
                        setslider={setUsbValue}
                        value={value}
                        top="0"
                        right="9vw"
                    />
                </div>
            )
        } else {
            return null
        }
    }

    const onClickDelete = (e, val) => {
        setChildren((arr) => arr.filter((ele, index) => index !== e))
        allDetails = JSON.parse(sessionStorage.getItem('allDetails'))
        if (allDetails !== null) {
            delete allDetails[val]
            deleteRecord(val)
            sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
            sessionStorage.removeItem(val)
        }
    }

    return (
        <>
            <div
                id={value}
                style={{
                    position: 'relative',
                    top:
                        enable.s1.pc === true
                            ? `${43 * id}vh`
                            : `${35 * id}vh`,
                }}
            >
                <img
                    src={popupCard}
                    draggable="false"
                    alt="popCard"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '25vh',
                        left: '49.2vw',
                        width: '100vw',
                        height: '29vh',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
                <img
                    src={ellipse}
                    draggable="false"
                    alt="ellipse"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '25.0vh',
                        left: '8.6vw',
                        width: '1.1vw',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
                <img
                    src={close}
                    draggable="false"
                    alt="close"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        marginBottom: 'auto',
                        top: '18vh',
                        left: '90.8vw',
                        width: '2vw',
                        cursor: 'pointer',
                    }}
                    onClick={() => onClickDelete(id, value)}
                />
                {/* Single flex row — if · [trigger select] · [model name] · is · [renderobject] */}
                <div
                    style={{
                        position: 'absolute',
                        top: '25vh',
                        left: '10vw',
                        right: '12vw',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1.8vw',
                        justifyContent: 'flex-start',
                        flexWrap: 'nowrap',
                        overflow: 'visible',
                    }}
                >
                    <span
                        className={styles.labelTag}
                        style={{
                            fontSize: '1.9vh',
                            fontWeight: '700',
                            letterSpacing: '0.5px',
                            color: '#444',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        if
                    </span>

                    <select
                        className={styles.selectBox}
                        style={{
                            width: currentOption === 'Face Detected' ? '15vw' : '20vw',
                            textAlign: 'center',
                            flexShrink: 0,
                        }}
                        id={value}
                        value={currentOption}
                        onChange={handleOnChange}
                    >
                        <option value="none">Select an Option</option>
                        {renderoptions()}
                    </select>

                    {currentOption === 'Face Detected' && (
                        <span
                            className={styles.labelTag}
                            style={{
                                fontSize: '1.8vh',
                                color: '#555',
                                letterSpacing: '0.3px',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            Model name :{' '}
                            <span className={styles.labelTagStrong}>
                                {currentModel.modelName}
                            </span>
                        </span>
                    )}

                    {currentOption !== 'speech recognition' && (
                        <span
                            className={styles.labelTag}
                            style={{
                                fontSize: '1.9vh',
                                fontWeight: '700',
                                color: '#444',
                                letterSpacing: '0.5px',
                                whiteSpace: 'nowrap',
                            }}
                        >
                            is
                        </span>
                    )}

                    {renderobject()}
                </div>
                <div>
                    <Action
                        key={id}
                        id={id}
                        value={value}
                        object={details}
                    />
                </div>
            </div>
            <div
                style={{
                    position: 'absolute',
                    top:
                        enable.s1.pc === true
                            ? `${43 * id}vh`
                            : `${35 * id}vh`,
                }}
                ref={messagesEndRef}
            ></div>
        </>
    )
}

const InnerRender = (props) => {
    const { enable, connectedDevice, setChildren, messagesEndRef } = props;
    const { deleteRecord } = useIndexedDB('ProgramData');
    
    const [selectedModelId, setSelectedModelId] = useState(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}
            return (
                all[props.value]?.modelId || props.currentModel?.modelId || null
            )
        })

        const getAllDetails = () =>
            JSON.parse(sessionStorage.getItem('allDetails')) || {}

        const all = getAllDetails()

        const [selectedClassId, setSelectedClassId] = useState(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}
            return all[props.value]?.selectedClassId || null
        })
        const [selectedRegionId, setSelectedRegionId] = useState(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}
            return all[props.value]?.selectedRegionId || 'none'
        })

        const selectedModel =
            props.camModels.find(
                (model) => String(model.modelId) === String(selectedModelId)
            ) || null

        useEffect(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}

            const storedClass = all[props.value]?.selectedClassId

            if (storedClass) {
                setSelectedClassId(storedClass)
            } else {
                setSelectedClassId(null)
            }
        }, [selectedModelId])

        useEffect(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}

            // If this IF block does not have modelId yet,
            // store the default selectedModelId immediately
            if (!all[props.value]?.modelId && selectedModelId) {
                all[props.value] = {
                    ...(all[props.value] || {}),
                    modelId: selectedModelId,
                }

                sessionStorage.setItem('allDetails', JSON.stringify(all))
            }
        }, [])

        useEffect(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}
            const storedRegion = all[props.value]?.selectedRegionId

            if (!selectedModel) {
                setSelectedRegionId('none')
                return
            }

            // If no region stored yet
            if (!storedRegion) {
                setSelectedRegionId('none')
                return
            }

            // If user selected none or all → accept directly
            if (storedRegion === 'none' || storedRegion === 'all') {
                setSelectedRegionId(storedRegion)
                return
            }

            // Otherwise check if specific ROI still exists
            const regionExists = selectedModel.roiRegions?.some(
                (r) => String(r.id) === String(storedRegion)
            )

            if (regionExists) {
                setSelectedRegionId(storedRegion)
            } else {
                setSelectedRegionId('none')

                if (all[props.value]) {
                    all[props.value].selectedRegionId = 'none'
                    sessionStorage.setItem('allDetails', JSON.stringify(all))
                }
            }
        }, [selectedModel])

        const [imageDetails, setImageDetails] = useState([])

        const roiRegions = React.useMemo(() => {
            return selectedModel?.roiRegions || []
        }, [selectedModel])

        console.log('camModels', props.camModels)

        console.log('Selected Model in Render:', selectedModel)

        let details = {
            id: props.value,
            modelId: selectedModelId,
            selectedClassId: null,
            selectedRegionId: 'none',
            usbValue: null,
            speechText: null,
            image: null,
            imageURL: null,
            displayText: null,
            selectedSize: null,
            selectedObject: null,
            option: null,
            sliderValue: '1',
            sliderOption: null,
        }

        useEffect(() => {
            if (!selectedModel) {
                setImageDetails([])
                return
            }

            let ImageClasses = selectedModel.ImageClasses || {}

            const resultArray = Object.values(ImageClasses).map(
                ({ id, className }) => ({
                    id,
                    className,
                })
            )

            setImageDetails(resultArray)
        }, [selectedModel, selectedModelId, props.camModels])

        const [currentOption, setcurrentOption] = useState(() => {
            if (
                sessionStorage.getItem('allDetails') !== null &&
                `${props.value}` in
                    JSON.parse(sessionStorage.getItem('allDetails')) &&
                JSON.parse(sessionStorage.getItem('allDetails'))[
                    `${props.value}`
                ].option !== null
            ) {
                return JSON.parse(sessionStorage.getItem('allDetails'))[
                    `${props.value}`
                ].option
            } else {
                return 'none'
            }
        })

        const [speechText, setSpeechText] = useState(() => {
            if (
                sessionStorage.getItem('allDetails') !== null &&
                `${props.value}` in
                    JSON.parse(sessionStorage.getItem('allDetails')) &&
                JSON.parse(sessionStorage.getItem('allDetails'))[
                    `${props.value}`
                ].speechText !== null
            ) {
                return JSON.parse(sessionStorage.getItem('allDetails'))[
                    `${props.value}`
                ].speechText
            } else {
                return ''
            }
        })

        // const [usbValue, setUsbValue] = useState(() => {
        //     if (
        //         sessionStorage.getItem('allDetails') !== null &&
        //         `${props.value}` in
        //             JSON.parse(sessionStorage.getItem('allDetails')) &&
        //         JSON.parse(sessionStorage.getItem('allDetails'))[
        //             `${props.value}`
        //         ].usbValue !== null
        //     ) {
        //         return JSON.parse(sessionStorage.getItem('allDetails'))[
        //             `${props.value}`
        //         ].usbValue
        //     } else {
        //         return null
        //     }
        // })

        const [usbValue, setUsbValue] = useState(() => {
            const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}

            if (
                all[props.value]?.usbValue !== null &&
                all[props.value]?.usbValue !== undefined
            ) {
                return all[props.value].usbValue
            }

            return 0
        })

        const [object, setObject] = useState(() => {
            if (
                sessionStorage.getItem('allDetails') !== null &&
                `${props.value}` in
                    JSON.parse(sessionStorage.getItem('allDetails')) &&
                JSON.parse(sessionStorage.getItem('allDetails'))[
                    `${props.value}`
                ].selectedObject !== null
            ) {
                return JSON.parse(sessionStorage.getItem('allDetails'))[
                    `${props.value}`
                ].selectedObject
            } else {
                return 'none'
            }
        })

        const getData = (event) => {
            const allDetails =
                JSON.parse(sessionStorage.getItem('allDetails')) || {}
            if (props.value in allDetails) {
                if (event.target.type === 'text') {
                    allDetails[props.value]['speechText'] = event.target.value
                } else if (
                    event.target.type === 'range' ||
                    event.target.type === 'number'
                ) {
                    allDetails[props.value]['usbValue'] = Number(
                        event.target.value
                    )
                } else {
                    if (event.target.type !== 'number') {
                        allDetails[props.value]['selectedObject'] =
                            event.target.value
                        setObject(event.target.value)
                    }
                }
            } else {
                if (event.target.type === 'text') {
                    details['speechText'] = event.target.value
                } else if (
                    event.target.type === 'range' ||
                    event.target.type === 'number'
                ) {
                    details['usbValue'] = event.target.value
                } else {
                    if (event.target.type !== 'number') {
                        details['selectedObject'] = event.target.value
                        setObject(event.target.value)
                    }
                }
                allDetails[`${props.value}`] = details
            }
            sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
        }

        const handleOnChange = (e) => {
            setcurrentOption(e.target.value)
            const allDetails =
                JSON.parse(sessionStorage.getItem('allDetails')) || {}
            if (props.value in allDetails) {
                allDetails[props.value]['option'] = e.target.value
                allDetails[props.value]['selectedObject'] = null
                allDetails[props.value]['speechText'] = null
                allDetails[props.value]['usbValue'] = null
                setSpeechText('')
                setUsbValue(0)
                setObject('none')
            } else {
                details['option'] = e.target.value
                allDetails[`${props.value}`] = details
            }
            sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
        }

        //get device name that show in ui
        const getDeviceName = () => {
            switch (connectedDevice) {
                case 'Ace':
                    return 'PC'
                case 'Humanoid':
                    return 'Zing'
                case 'Hexapod':
                    return 'Crawl-e'
                case 'Klaw':
                    return 'Klaw-b'
                case 'Roboki':
                    return 'Roboki'
                case 'Autoki':
                    return 'Autoki'
                case 'Klaw':
                    return 'klaw-b'
                default:
                    return connectedDevice
            }
        }

        const renderoptions = () => {
            if (
                enable.s1.cam === true &&
                enable.s1.mic === true &&
                enable.s1.pc
            ) {
                if (enable.s2.face === true) {
                    return (
                        <>
                            <option value="Face Detected">Cam Detected</option>
                            <option value="Speech Recognized">
                                Speech Recognized
                            </option>
                            <option value="USB">
                                {' '}
                                {`Data recieved from ${getDeviceName()} (USB TX)`}
                            </option>
                        </>
                    )
                } else if (enable.s2.emotion === true) {
                    return (
                        <>
                            <option value="Emotion Detected">
                                Emotion Detected
                            </option>
                            <option value="Speech Recognized">
                                Speech Recognized
                            </option>
                            <option value="USB">
                                {' '}
                                {`Data recieved from ${getDeviceName()} (USB TX)`}
                            </option>
                        </>
                    )
                } else if (enable.s2.object === true) {
                    return (
                        <>
                            <option value="Object Detected">
                                Object Detected
                            </option>
                            <option value="Speech Recognized">
                                Speech Recognized
                            </option>
                            <option value="USB">
                                {' '}
                                {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                            </option>
                        </>
                    )
                }
            } else if (enable.s1.cam === true && enable.s1.mic === true) {
                if (enable.s2.face === true) {
                    return (
                        <>
                            <option value="Face Detected">Cam Detected</option>
                            <option value="Speech Recognized">
                                Speech Recognized
                            </option>
                        </>
                    )
                } else if (enable.s2.emotion === true) {
                    return (
                        <>
                            <option value="Emotion Detected">
                                Emotion Detected
                            </option>
                            <option value="Speech Recognized">
                                Speech Recognized
                            </option>
                        </>
                    )
                } else if (enable.s2.object === true) {
                    return (
                        <>
                            <option value="Object Detected">
                                Object Detected
                            </option>
                            <option value="Speech Recognized">
                                Speech Recognized
                            </option>
                        </>
                    )
                }
            } else if (enable.s1.cam === true && enable.s1.pc === true) {
                if (enable.s2.face === true) {
                    return (
                        <>
                            <option value="Face Detected">Cam Detected</option>
                            <option value="USB">
                                {' '}
                                {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                            </option>
                        </>
                    )
                } else if (enable.s2.emotion === true) {
                    return (
                        <>
                            <option value="Emotion Detected">
                                Emotion Detected
                            </option>
                            <option value="USB">
                                {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                            </option>
                        </>
                    )
                } else if (enable.s2.object === true) {
                    return (
                        <>
                            <option value="Object Detected">
                                Object Detected
                            </option>
                            <option value="USB">
                                {' '}
                                {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                            </option>
                        </>
                    )
                }
            } else if (enable.s1.mic === true && enable.s1.pc === true) {
                return (
                    <>
                        <option value="Speech Recognized">
                            Speech Recognized
                        </option>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                        </option>
                    </>
                )
            } else if (enable.s1.cam === true) {
                if (enable.s2.face === true) {
                    return <option value="Face Detected">Cam Detected</option>
                } else if (enable.s2.emotion === true) {
                    return (
                        <option value="Emotion Detected">
                            Emotion Detected
                        </option>
                    )
                } else if (enable.s2.object === true) {
                    return (
                        <option value="Object Detected">Object Detected</option>
                    )
                }
            } else if (enable.s1.mic === true) {
                return (
                    <option value="Speech Recognized">
                        {' '}
                        Speech Recognized{' '}
                    </option>
                )
            } else if (enable.s1.pc === true) {
                return (
                    <>
                        <option value="USB">
                            {' '}
                            {`Data recieved from ${getDeviceName()} (USB TX)`}{' '}
                        </option>
                    </>
                )
            }
        }

        const updateField = (ele) => {
            setSpeechText(ele.target.value)
            getData(ele)
        }

        const renderobject = () => {
            if (currentOption === 'Face Detected') {
                return null
            } else if (currentOption === 'Emotion Detected') {
                let emotionList = [
                    'Suprise',
                    'Fear',
                    'Angry',
                    'Neutral',
                    'Sad',
                    'Disgust',
                    'Happy',
                ]
                return (
                    <label>
                        {' '}
                        <select
                            className={styles.selectBox}
                            style={{
                                width: '18vw',
                                textAlign: 'center',
                            }}
                            id={props.value}
                            onChange={getData}
                            value={object}
                        >
                            <option value="none">Select an option</option>;
                            {emotionList.map((value, index) => {
                                return (
                                    <option key={index} value={value}>
                                        {value}
                                    </option>
                                )
                            })}
                        </select>
                    </label>
                )
            } else if (currentOption === 'Object Detected') {
                return (
                    <label>
                        {' '}
                        <select
                            className={styles.selectBox}
                            style={{
                                width: '18vw',
                                textAlign: 'center',
                            }}
                            id={props.value}
                            onChange={getData}
                            value={object}
                        >
                            <option value="none">Select an option</option>;
                            {Object.keys(ObjectDetails).map((value, index) => {
                                return (
                                    <option
                                        key={index}
                                        value={ObjectDetails[value].displayName}
                                    >
                                        {ObjectDetails[value].displayName}
                                    </option>
                                )
                            })}
                        </select>
                    </label>
                )
            } else if (currentOption === 'Speech Recognized') {
                // Audio training model: show class dropdown
                if (props.audioDetails && props.audioDetails.length > 0) {
                    return (
                        <label>
                            <select
                                className={styles.selectBox}
                                style={{
                                    width: '18vw',
                                    textAlign: 'center',
                                }}
                                id={props.value}
                                onChange={getData}
                                value={object}
                            >
                                <option value="none">Select a class</option>
                                {props.audioDetails.map((c) => (
                                    <option key={c.classKey} value={c.classKey}>
                                        {c.className}
                                    </option>
                                ))}
                            </select>
                        </label>
                    )
                }
                // Standard speech-to-text: show text input
                return (
                    <>
                        <input
                            style={{
                                margin: 0,
                                width: '18vw',
                                textAlign: 'center',
                            }}
                            key="speech"
                            className={styles.inputWrapper}
                            type="text"
                            id={props.value}
                            placeholder="Enter text"
                            value={speechText}
                            onChange={updateField}
                        />
                    </>
                )
            } else if (currentOption === 'USB') {
                return (
                    <Slider
                        save={getData}
                        slider={usbValue}
                        setslider={setUsbValue}
                        value={props.value}
                        inline={true}
                    />
                )
            } else {
                return null
            }
        }

        const onClickDelete = (e, value) => {
            setChildren((arr) => arr.filter((ele, index) => index !== e))
            const allDetails =
                JSON.parse(sessionStorage.getItem('allDetails')) || {}
            if (allDetails !== null) {
                delete allDetails[value]
                deleteRecord(value)
                sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
                sessionStorage.removeItem(value)
            }
        }

        return (
            <>
                <div
                    id={props.value}
                    style={{
                        position: 'relative',
                        top:
                            enable.s1.pc === true
                                ? `${43 * props.id}vh`
                                : `${35 * props.id}vh`,
                    }}
                >
                    <img
                        src={popupCard}
                        draggable="false"
                        alt="popCard"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '25vh',
                            left: '49.2vw',
                            width: '100vw',
                            height: '29vh',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={ellipse}
                        draggable="false"
                        alt="ellipse"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            top: '25.0vh',
                            left: '8.6vw',
                            width: '1.1vw',
                            transform: 'translate(-50%, -50%)',
                        }}
                    />
                    <img
                        src={close}
                        draggable="false"
                        alt="close"
                        style={{
                            margin: 0,
                            position: 'absolute',
                            marginBottom: 'auto',
                            top: '18vh',
                            left: '90.8vw',
                            width: '2vw',
                            cursor: 'pointer',
                        }}
                        onClick={() => onClickDelete(props.id, props.value)}
                    />
                    <div>
                        {/* Element to Move Dynamically */}
                        <h2
                            style={{
                                position: 'absolute',
                                top: '25vh',
                                left: '12vw',
                                margin: 0,
                                transform: 'translateY(-50%)',
                                font: 'Halcyon Regular',
                                fontFamily: 'Halcyon Regular',
                                fontSize: '1.9vh',
                                color: 'black',
                            }}
                        >
                            <strong>if</strong>
                        </h2>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '25vh',
                            left:
                                currentOption === 'Face Detected'
                                    ? '16vw'
                                    : '38vw',
                            transform: 'translateY(-50%)',
                        }}
                    >
                        <select
                            className={styles.selectBox}
                            style={
                                currentOption === 'Face Detected'
                                    ? {
                                          width: '15vw',
                                          height: '5.5vh',
                                          fontSize: '12px',
                                          textAlign: 'center',
                                      }
                                    : {
                                          width: '20vw',
                                          textAlign: 'center',
                                      }
                            }
                            id={props.value}
                            value={currentOption}
                            onChange={handleOnChange}
                        >
                            <option value="none">Select an Option</option>
                            {renderoptions()}
                        </select>
                    </div>

                    {currentOption === 'USB' && (
                        <h2
                            style={{
                                position: 'absolute',
                                top: '25vh',
                                left: '62vw',
                                margin: 0,
                                transform: 'translateY(-50%)',
                                fontFamily: 'Halcyon Regular',
                                fontSize: '1.9vh',
                                color: 'black',
                            }}
                        >
                            <strong>is</strong>
                        </h2>
                    )}

                    <div
                        style={{
                            position: 'absolute',
                            top: '25vh',
                            left: '70vw',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {renderobject()}
                    </div>

                    {currentOption === 'Face Detected' && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '21.6vh',
                                left: '36vw',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '1vw',
                            }}
                        >
                            {/* WHEN LABEL */}
                            <span
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 700,
                                    color: '#000',
                                }}
                            >
                                with
                            </span>
                            {/* MODEL */}
                            <select
                                className={styles.selectBox}
                                style={{
                                    width: '12vw',
                                    height: '5.5vh',
                                    textAlign: 'center',
                                }}
                                value={selectedModelId}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setSelectedModelId(value)

                                    let all =
                                        JSON.parse(
                                            sessionStorage.getItem('allDetails')
                                        ) || {}

                                    if (!all[props.value]) {
                                        all[props.value] = { id: props.value }
                                    }

                                    all[props.value].modelId = value
                                    all[props.value].selectedClassId = null
                                    all[props.value].selectedRegionId = 'none'

                                    setSelectedRegionId('none')
                                    setSelectedClassId(null)

                                    sessionStorage.setItem(
                                        'allDetails',
                                        JSON.stringify(all)
                                    )
                                }}
                            >
                                {props.camModels.map((model) => (
                                    <option
                                        key={model.modelId}
                                        value={model.modelId}
                                    >
                                        {model.modelName}
                                    </option>
                                ))}
                            </select>

                            <span
                                style={{
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    color: '#000',
                                }}
                            >
                                of
                            </span>

                            {/* CLASS */}
                            <select
                                className={styles.selectBox}
                                style={{
                                    width: '12vw',
                                    height: '5.5vh',
                                    textAlign: 'center',
                                }}
                                value={selectedClassId || 'none'}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setSelectedClassId(value)

                                    let all =
                                        JSON.parse(
                                            sessionStorage.getItem('allDetails')
                                        ) || {}

                                    if (!all[props.value]) {
                                        all[props.value] = { id: props.value }
                                    }

                                    all[props.value].selectedClassId = value

                                    sessionStorage.setItem(
                                        'allDetails',
                                        JSON.stringify(all)
                                    )
                                }}
                            >
                                <option value="none">Select Class</option>
                                {imageDetails.map((value) => (
                                    <option key={value.id} value={value.id}>
                                        {value.className}
                                    </option>
                                ))}
                            </select>

                            <span
                                style={{
                                    fontSize: '13px',
                                    fontWeight: 700,
                                    color: '#000',
                                }}
                            >
                                in region
                            </span>

                            {/* REGION */}
                            {/* REGION */}
                            <select
                                className={styles.selectBox}
                                style={{
                                    width: '12vw',
                                    height: '5.5vh',
                                    textAlign: 'center',
                                }}
                                value={selectedRegionId}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setSelectedRegionId(value)

                                    let all =
                                        JSON.parse(
                                            sessionStorage.getItem('allDetails')
                                        ) || {}

                                    if (!all[props.value]) {
                                        all[props.value] = { id: props.value }
                                    }

                                    all[props.value].selectedRegionId = value

                                    sessionStorage.setItem(
                                        'allDetails',
                                        JSON.stringify(all)
                                    )
                                }}
                            >
                                <option value="none">
                                    No Region (Full Frame)
                                </option>
                                <option value="all">All Regions</option>
                                {roiRegions.map((region) => (
                                    <option key={region.id} value={region.id}>
                                        {region.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div>
                        <Action
                            id={props.id}
                            value={props.value}
                            object={details}
                        />
                    </div>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top:
                            enable.s1.pc === true
                                ? `${43 * props.id}vh`
                                : `${35 * props.id}vh`,
                    }}
                    ref={messagesEndRef}
                ></div>
            </>
        )
}

const ProgrammingPage = (props) => {
    // const { getAll } = useIndexedDB('SavedFaces')
    const enable = JSON.parse(sessionStorage.getItem('enable'))
    const [imageDetails, setImageDetails] = useState([])
    const [audioDetails, setAudioDetails] = useState([])
    const [isHumenVoise, setisHumanVoise] = useState({})
    const { deleteRecord } = useIndexedDB('ProgramData')
    const messagesEndRef = useRef(null)
    const history = useHistory()
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const [count, setCount] = useState(
        JSON.parse(sessionStorage.getItem('count')) || 0
    )
    const [children, setChildren] = useState(
        JSON.parse(sessionStorage.getItem('arr')) || []
    )
    const [ishelpButton, sethelpButton] = useState(false)

    const connectedDevice = sessionStorage.getItem('connectedDevice')
    let currentModel = props.camModels.find(
        (model) => model.modelId === props?.currentModelId
    )
    
    const handleClickhelpbtn = () => {
        sethelpButton(true)
    }

    const closeModal = () => {
        sethelpButton(false)
    }

    useEffect(() => {
        let ImageClasses = currentModel?.ImageClasses || {}
        let AudioClasses = currentModel?.AudioClasses || {}

        const imageClassArray = Object.values(ImageClasses).map(
            ({ id, className }) => ({
                id,
                className,
            })
        )

        const audioClassArray = Object.entries(AudioClasses)
            .filter(([, { className, id }]) => {
                if (className === 'Background_Noise') return false
                if (id === 'sliderValue') return false
                return true
            })
            .map(([classKey, { id, className, CategoryName }]) => ({
                classKey,
                id,
                className,
                CategoryName,
            }))

        setAudioDetails((prev) => {
            if (JSON.stringify(prev) === JSON.stringify(audioClassArray))
                return prev
            return audioClassArray
        })
        setImageDetails((prev) => {
            if (JSON.stringify(prev) === JSON.stringify(imageClassArray))
                return prev
            return imageClassArray
        })
    }, [currentModel])

    useEffect(() => {
        const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}
        let updated = false

        Object.keys(all).forEach((key) => {
            const block = all[key]

            if (!block.modelId) return

            const modelExists = props.camModels.find(
                (m) => String(m.modelId) === String(block.modelId)
            )

            if (!modelExists && props.camModels.length > 0) {
                block.modelId = props.camModels[0].modelId
                block.selectedObject = null
                updated = true
            }
        })

        if (updated) {
            sessionStorage.setItem('allDetails', JSON.stringify(all))
        }
    }, [props.camModels])

    useEffect(() => {
        sessionStorage.setItem('count', count)
    }, [count])

    useEffect(() => {
        if (messagesEndRef.current !== null) {
            messagesEndRef.current.scrollIntoView({
                behavior: 'smooth',
            })
        }
        sessionStorage.setItem('arr', JSON.stringify(children))
    }, [children])


    return (
        <div>
            <div>
                {/* <NavBar
                    selectbar={selectbarX}
                    selectbarwidth="55%"
                    headers={[
                        { name: 'Enable', color: 'white' },
                        { name: 'Control', color: 'white' },
                        { name: 'Run', color: 'black' },
                    ]}
                    save={true}
                    showHelp={true}
                    handleHelp={handleClickhelpbtn}
                /> */}
                   <ProgramHeader
                            data={{
                                selected: 1,
                                options: [
                                    <p key="Enable">Enable</p>,
                                    <p key="Control">Control</p>,
                                    <p key="Run">Run</p>
                                ],
                            }}
                            showSave={true}
                            showHelp={true}
                            handleHelp={handleClickhelpbtn}

                    />
            </div>

            <div className={styles.scrollable}>
                <div
                    className={`${
                        slideDirection === 'true' ? 'slide-right' : 'slide-left'
                    }`}
                >
                    {children.map((value, index) => (
                        <div
                            key={`${value}-${index}`}
                            style={{ position: 'relative', top: '-13vh' }}
                        >
                            <InnerRender
                                value={value}
                                id={index}
                                camModels={props.camModels}
                                currentModel={currentModel}
                                audioDetails={audioDetails}
                                imageDetails={imageDetails}
                                setisHumanVoise={setisHumanVoise}
                                isHumenVoise={isHumenVoise}
                                enable={enable}
                                connectedDevice={connectedDevice}
                                setChildren={setChildren}
                                messagesEndRef={messagesEndRef}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <div style={{ background: 'clear' }}>
                <ProgrammingPageFooter
                    setSlideDirection={setSlideDirection}
                    enable={enable}
                    count={count}
                    setCount={setCount}
                    children={children}
                    setChildren={setChildren}
                    backY={backY}
                    buttonPlus={buttonPlus}
                    nextY={nextY}
                />
            </div>

            {ishelpButton == true ? (
                <div
                    style={{
                        height: '100vh',
                        width: '100vw',
                        background: 'rgba(255,255,255,0.97)',
                        backdropFilter: 'blur(4px)',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        zIndex: '100000',
                    }}
                >
                    <div
                        onClick={closeModal}
                        style={{
                            borderRadius: '50%',
                            zIndex: '2000',
                            position: 'absolute',
                            top: '3vh',
                            right: '3vw',
                            cursor: 'pointer',
                            padding: '4px',
                            transition: 'opacity 0.2s ease',
                        }}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                    >
                        <img
                            src={closeBtn}
                            style={{ width: '6vh', height: 'auto', display: 'block' }}
                        />
                    </div>
                    <Sliders
                        {...settings}
                        style={{
                            transform: 'translate(-50%,-50%)',
                            top: '46%',
                            left: '50%',
                            zIndex: '10',
                            position: 'absolute',
                        }}
                    >
                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                            }}
                        >
                            <img
                                src={renderPrgImage('PrgmH')}
                                style={{
                                    width: '100%',
                                }}
                            />

                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '54%',
                                    left: '21%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '22vw',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '10px 14px',
                                        fontSize: '1.9vh',
                                        lineHeight: '1.65',
                                        textAlign: 'left',
                                        color: '#555',
                                        fontFamily: "'Halcyon Regular', sans-serif",
                                        borderRadius: '10px',
                                        marginBottom: '0',
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    This block is for the <strong>if condition</strong>, to check
                                    whether the programmed condition is
                                    satisfied or not. The drop-down
                                    options from the if condition are enabled
                                    based on the feature enabled at the
                                    previous screens.
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('PrgmH1')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    width: '20vw',
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '70%',
                                    left: '27.7%',
                                    transform: 'translate(-50%,-50%)',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '10px 14px',
                                        fontSize: '1.9vh',
                                        lineHeight: '1.65',
                                        textAlign: 'left',
                                        color: '#555',
                                        fontFamily: "'Halcyon Regular', sans-serif",
                                        borderRadius: '10px',
                                        marginBottom: '0',
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    Use this button when you want to add
                                    multiple lines of <strong>if &amp; Action</strong> blocks for the
                                    app programming.
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('PrgmH2')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    width: '20vw',
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '68%',
                                    left: '37.6%',
                                    transform: 'translate(-50%,-50%)',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '10px 14px',
                                        fontSize: '1.9vh',
                                        lineHeight: '1.65',
                                        textAlign: 'left',
                                        color: '#555',
                                        fontFamily: "'Halcyon Regular', sans-serif",
                                        borderRadius: '10px',
                                        marginBottom: '0',
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    At this <strong>Action</strong>, you can enter any text you
                                    want to display when the if condition is
                                    true. The size of the text can be selected
                                    from the size drop-down.
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('PrgmH3')}
                                style={{ width: '100%' }}
                            />

                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '59.5%',
                                    left: '46%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '20vw',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '10px 14px',
                                        fontSize: '1.9vh',
                                        lineHeight: '1.65',
                                        textAlign: 'left',
                                        color: '#555',
                                        fontFamily: "'Halcyon Regular', sans-serif",
                                        borderRadius: '10px',
                                        marginBottom: '0',
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    At this <strong>Action block</strong>, you select any image
                                    (taken from your Mobile gallery or Desktop
                                    folders) to show the image as an output
                                    when running the program.
                                </p>
                            </div>
                        </div>

                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                background: '#fff',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                zIndex: '1000',
                            }}
                        >
                            <img
                                src={renderPrgImage('PrgmH4')}
                                style={{ width: '100%' }}
                            />
                            <div
                                style={{
                                    zIndex: '2000',
                                    position: 'absolute',
                                    top: '49%',
                                    left: '54.2%',
                                    transform: 'translate(-50%,-50%)',
                                    width: '20vw',
                                }}
                            >
                                <p
                                    style={{
                                        backgroundColor: 'white',
                                        padding: '10px 14px',
                                        fontSize: '1.9vh',
                                        lineHeight: '1.65',
                                        textAlign: 'left',
                                        color: '#555',
                                        fontFamily: "'Halcyon Regular', sans-serif",
                                        borderRadius: '10px',
                                        marginBottom: '0',
                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    When an if condition is true, use this
                                    action to send a set data value to the selected
                                    device.
                                </p>
                            </div>
                        </div>
                    </Sliders>
                </div>
            ) : null}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        camModels: state.appModeStorage.trainMachine.camModels,
        currentModelId: state.appModeStorage.trainMachine.currentModelId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgrammingPage)
